import React from "react";
import { Row, Col } from "reactstrap";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlane, faBattery4, faWeightHanging } from '@fortawesome/free-solid-svg-icons';

const Applications = () => {
  return (
    <>
      <h2 className="text-center title" style={{ color: "white", marginTop: '20px', marginBottom: '20px', fontWeight: 'bolder'}}>Applications</h2>
      <Row className="justify-content-center">
        <Col xs={12} lg={4} md={12} className="text-center text-lg-left d-flex align-items-center mb-4 mb-md-0 order-lg-1 order-1">
          <p style={{ color: "white", fontSize: '1.25em', marginBottom: '20px'}}>
            <span style={{ fontSize: '1.75em', color: "white"}}>Urban Air Mobility Air Taxi<br/><br/></span>
            Our air taxi concept, propelled by our innovative MagLev HyperDrive&trade; system, ensures swift, quiet, and eco-friendly transit. 
            With enhanced safety features, increased passenger capacity, and superior flight capabilities, the HyperDelta&trade; redefines the future of urban transportation.
          </p>
        </Col>
        <Col xs={12} lg={8} md={12} className="text-center d-flex align-items-center mb-4 mb-md-0 order-md-1 order-sm-1 order-xs-1 order-1">
          <div className="embed-responsive embed-responsive-16by9" style={{ color: "white", fontSize: '1.25em', marginBottom: '20px'}} >
              <iframe
                title="Vision Reel"
                src="https://player.vimeo.com/video/855112851?h=c93481be41"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
                className="embed-responsive-item"
                style={{ maxWidth: '100%', maxHeight: '100%'}}
              ></iframe>
          </div>
        </Col>
      </Row>
      <div style={{ textAlign: 'center' }}>
        <h3 className="title" style={{ lineHeight: "150%", fontSize: '2.25em', marginTop: '20px' }}>Other Use Cases</h3>
        <div id="use-cases-section" className="d-flex flex-md-row flex-column justify-content-center align-items-center" style={{ marginTop: '20px'}}>
          {/* Drone Icon and Text */}
          <div className="text-center mb-4 mb-md-0" style={{ width: '300px' }}>
            <FontAwesomeIcon icon={faWeightHanging} style={{ fontSize: '2.5em', color: 'white' }} />
            <i className="icon-drone" style={{ fontSize: '2em', color: 'white' }} />
            <h4 style={{ color: 'white' }}>Heavy Lift Drone</h4>
            <p style={{ color: 'white', padding:'20px' }}>Tactical and Commercial<br/>Logistics Drones</p>
          </div>
          {/* Cargo Icon and Text */}
          <div className="text-center mb-4 mb-md-0" style={{ width: '300px' }}>
            <FontAwesomeIcon icon={faBattery4} style={{ fontSize: '2.5em', color: 'white' }} />
            <i className="icon-cargo" style={{ fontSize: '2em', color: 'white' }} />
            <h4 style={{ color: 'white' }}>UAM eVTOL</h4>
            <p style={{ color: 'white', padding:'20px' }}>Efficient, sustainable, cost effective, and robust propulsion.<br/>Transmission for air, land, sea, and space.</p>
          </div>
          {/* Passenger Icon and Text */}
          <div className="text-center mb-4 mb-md-0" style={{ width: '300px' }}>
            <FontAwesomeIcon icon={faPlane} style={{ fontSize: '2.5em', color: 'white' }} />
            <i className="icon-passenger" style={{ fontSize: '2em', color: 'white' }} />
            <h4 style={{ color: 'white' }}>Aviation Propulsion</h4>
            <p style={{ color: 'white', padding:'20px'  }}>Efficient, sustainable, cost effective, and robust propulsion.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Applications;
